export const SECTION_NAME_SERVICE_COUPON = {
  HOVERABLE_MENU: 'hoverable menu',
  LISTING_PAGE: 'listing page',
  INFORMASI_MOBIL_TOYOTA: 'informasi mobil toyota',
  FILTER: 'filter',
  SORT: 'urutkan',
};

export const BUTTON_NAME_SERVICE_COUPON = {
  RESET_FILTER: 'reset filter',
  PENAWARAN_KHUSUS: 'penawaran khusus',
  MODEL_MOBIL: 'model mobil',
  URUTKAN: 'urutkan',
  SEARCH: 'search',
};

export const PAGE_NAME_SERVICE_COUPON = {
  COUPON_SERVICE_LISTING_PAGE: 'kupon servis listing page',
};
